import angular from 'angular';
import geolocation from 'angularjs-geolocation';

// Libraries

// Translations
import translationModuleName from '../../../../../lib/translation';

// Load all services
import serviceModuleName from '../../../../../lib/service';

// Etc
import 'angular-moment/';
import filters from '../../../../../lib/filters';

// Component
import component from './invitationPositionDisplayBox.component';

const moduleName = 'invitationPositionDisplayBox';
let module = angular.module(moduleName, [
  serviceModuleName,
  translationModuleName,
  filters.name,
  'angularMoment',
  'geolocation',
]);
module.component('invitationPositionDisplayBox', component);

export default module;
